// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ae0806cd","12":"d2a73b6c","21":"c96b0564","33":"68603e4f","86":"54cbc31e","115":"17d17f2e","271":"51d96cfe","374":"21cb9071","378":"cf497447","771":"3bff53c1","929":"34d005f1","944":"87192b1f"}[chunkId] + ".chunk.js";
};